import React, { useState } from "react"
import {Phone, MessageCircleDashed as MessageCircle, Calendar, Sparkles, Plus, X} from 'lucide-react'

interface QuickActionsProps {
  onBookPackage: () => void
  onBookConsult: () => void
}

const QuickActions: React.FC<QuickActionsProps> = ({ onBookPackage, onBookConsult }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="fixed bottom-24 left-4 md:bottom-24 md:left-auto md:right-6 z-40">
      {/* Expanded Action Buttons */}
      <div className={`flex flex-col gap-2 mb-2 transition-all duration-300 ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95 pointer-events-none'}`}>
        <a
          href="tel:858-282-8119"
          className="bg-black/90 backdrop-blur-md border border-cyan-500/40 hover:border-cyan-500/80 rounded-full px-4 py-2.5 flex items-center gap-2 transition-all hover:scale-105 shadow-lg hover:shadow-cyan-500/30 ml-auto"
        >
          <Phone size={16} className="text-cyan-400" />
          <span className="text-white text-sm font-medium">Call</span>
        </a>

        <a
          href="sms:858-282-8119"
          className="bg-black/90 backdrop-blur-md border border-cyan-500/40 hover:border-cyan-500/80 rounded-full px-4 py-2.5 flex items-center gap-2 transition-all hover:scale-105 shadow-lg hover:shadow-cyan-500/30 ml-auto"
        >
          <MessageCircle size={16} className="text-cyan-400" />
          <span className="text-white text-sm font-medium">Text</span>
        </a>

        <button
          onClick={() => { onBookPackage(); setIsOpen(false); }}
          className="bg-orange-500/95 backdrop-blur-md border border-orange-400/40 hover:bg-orange-600 rounded-full px-4 py-2.5 flex items-center gap-2 transition-all hover:scale-105 shadow-lg hover:shadow-orange-500/30 ml-auto whitespace-nowrap"
        >
          <Sparkles size={16} className="text-white" />
          <span className="text-white text-sm font-medium">Build Package</span>
        </button>

        <button
          onClick={() => { onBookConsult(); setIsOpen(false); }}
          className="bg-cyan-500/95 backdrop-blur-md border border-cyan-400/40 hover:bg-cyan-600 rounded-full px-4 py-2.5 flex items-center gap-2 transition-all hover:scale-105 shadow-lg hover:shadow-cyan-500/30 ml-auto whitespace-nowrap"
        >
          <Calendar size={16} className="text-white" />
          <span className="text-white text-sm font-medium">10-Min Consult</span>
        </button>
      </div>

      {/* Main FAB Toggle Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="bg-gradient-to-br from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white rounded-full w-14 h-14 md:w-16 md:h-16 flex items-center justify-center shadow-2xl hover:shadow-orange-500/50 transition-all hover:scale-110 ml-auto"
        aria-label="Quick Actions"
      >
        {isOpen ? <X size={24} /> : <Plus size={24} />}
      </button>
    </div>
  )
}

export default QuickActions
